(function () {
  var MOBILE_QUERY = '(max-width: 749px)';
  var BUTTON_CLASSES = ['button', 'button--full-width', 'button--secondary', 'quick-add__submit'];

  function applyState() {
    var isMobile = window.matchMedia(MOBILE_QUERY).matches;
    var buttons = document.querySelectorAll('.wf-quick-add');

    buttons.forEach(function (btn) {
      if (isMobile) {
        BUTTON_CLASSES.forEach(function (cls) {
          btn.classList.remove(cls);
        });
        btn.classList.add('wf-quick-add--bare');
      } else {
        BUTTON_CLASSES.forEach(function (cls) {
          btn.classList.add(cls);
        });
        btn.classList.remove('wf-quick-add--bare');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyState);
  } else {
    applyState();
  }

  window.matchMedia(MOBILE_QUERY).addEventListener('change', applyState);

  document.addEventListener('shopify:section:load', applyState);

  var observer = new MutationObserver(function () {
    applyState();
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
